/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * userAndPermissionApi API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  DeleteV7PermissionsGroupRolesParams,
  GetV7PermissionsGroupRolesAuthDefaultParams,
  GetV7PermissionsGroupRolesAuthParams,
  GetV7PermissionsGroupRolesAuthSettingParams,
  GetV7PermissionsGroupRolesParams,
  PatchV7PermissionsGroupRolesAuthParams,
  RoleGroupPermissionResponse,
  RoleGroupRolePermissionPatchRequest,
  RoleGroupRolePermissionResponse,
  SuccessResponse,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary getPermissionGroupRoles
 */
export const getV7PermissionsGroupRoles = (
  params?: MaybeRef<GetV7PermissionsGroupRolesParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<RoleGroupPermissionResponse>(
    { url: `/api/v7/permissions/group-roles`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7PermissionsGroupRolesQueryKey = (
  params?: MaybeRef<GetV7PermissionsGroupRolesParams>,
) => {
  return ['api', 'v7', 'permissions', 'group-roles', ...(params ? [params] : [])] as const;
};

export const getGetV7PermissionsGroupRolesQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PermissionsGroupRoles>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV7PermissionsGroupRolesParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7PermissionsGroupRoles>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PermissionsGroupRolesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7PermissionsGroupRoles>>> = ({
    signal,
  }) => getV7PermissionsGroupRoles(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PermissionsGroupRoles>>,
    TError,
    TData
  >;
};

export type GetV7PermissionsGroupRolesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PermissionsGroupRoles>>
>;
export type GetV7PermissionsGroupRolesQueryError = ErrorType<unknown>;

/**
 * @summary getPermissionGroupRoles
 */

export function useGetV7PermissionsGroupRoles<
  TData = Awaited<ReturnType<typeof getV7PermissionsGroupRoles>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV7PermissionsGroupRolesParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7PermissionsGroupRoles>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PermissionsGroupRolesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary deletePermissionGroupRoles
 */
export const deleteV7PermissionsGroupRoles = (
  params: MaybeRef<DeleteV7PermissionsGroupRolesParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  params = unref(params);

  return customAxiosInstance<SuccessResponse>(
    { url: `/api/v7/permissions/group-roles`, method: 'DELETE', params: unref(params) },
    options,
  );
};

export const getDeleteV7PermissionsGroupRolesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteV7PermissionsGroupRoles>>,
    TError,
    { params: DeleteV7PermissionsGroupRolesParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteV7PermissionsGroupRoles>>,
  TError,
  { params: DeleteV7PermissionsGroupRolesParams },
  TContext
> => {
  const mutationKey = ['deleteV7PermissionsGroupRoles'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteV7PermissionsGroupRoles>>,
    { params: DeleteV7PermissionsGroupRolesParams }
  > = (props) => {
    const { params } = props ?? {};

    return deleteV7PermissionsGroupRoles(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteV7PermissionsGroupRolesMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteV7PermissionsGroupRoles>>
>;

export type DeleteV7PermissionsGroupRolesMutationError = ErrorType<unknown>;

/**
 * @summary deletePermissionGroupRoles
 */
export const useDeleteV7PermissionsGroupRoles = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteV7PermissionsGroupRoles>>,
      TError,
      { params: DeleteV7PermissionsGroupRolesParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof deleteV7PermissionsGroupRoles>>,
  TError,
  { params: DeleteV7PermissionsGroupRolesParams },
  TContext
> => {
  const mutationOptions = getDeleteV7PermissionsGroupRolesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary getPermissionGroupRolesAuthList
 */
export const getV7PermissionsGroupRolesAuth = (
  params: MaybeRef<GetV7PermissionsGroupRolesAuthParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<RoleGroupRolePermissionResponse>(
    { url: `/api/v7/permissions/group-roles/auth`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7PermissionsGroupRolesAuthQueryKey = (
  params?: MaybeRef<GetV7PermissionsGroupRolesAuthParams>,
) => {
  return ['api', 'v7', 'permissions', 'group-roles', 'auth', ...(params ? [params] : [])] as const;
};

export const getGetV7PermissionsGroupRolesAuthQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PermissionsGroupRolesAuth>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7PermissionsGroupRolesAuthParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7PermissionsGroupRolesAuth>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PermissionsGroupRolesAuthQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7PermissionsGroupRolesAuth>>> = ({
    signal,
  }) => getV7PermissionsGroupRolesAuth(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PermissionsGroupRolesAuth>>,
    TError,
    TData
  >;
};

export type GetV7PermissionsGroupRolesAuthQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PermissionsGroupRolesAuth>>
>;
export type GetV7PermissionsGroupRolesAuthQueryError = ErrorType<unknown>;

/**
 * @summary getPermissionGroupRolesAuthList
 */

export function useGetV7PermissionsGroupRolesAuth<
  TData = Awaited<ReturnType<typeof getV7PermissionsGroupRolesAuth>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7PermissionsGroupRolesAuthParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7PermissionsGroupRolesAuth>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PermissionsGroupRolesAuthQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary patchPermissionGroupRolesAuthList
 */
export const patchV7PermissionsGroupRolesAuth = (
  roleGroupRolePermissionPatchRequest: MaybeRef<RoleGroupRolePermissionPatchRequest>,
  params?: MaybeRef<PatchV7PermissionsGroupRolesAuthParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  roleGroupRolePermissionPatchRequest = unref(roleGroupRolePermissionPatchRequest);
  params = unref(params);

  return customAxiosInstance<SuccessResponse>(
    {
      url: `/api/v7/permissions/group-roles/auth`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: roleGroupRolePermissionPatchRequest,
      params: unref(params),
    },
    options,
  );
};

export const getPatchV7PermissionsGroupRolesAuthMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV7PermissionsGroupRolesAuth>>,
    TError,
    {
      data: BodyType<RoleGroupRolePermissionPatchRequest>;
      params?: PatchV7PermissionsGroupRolesAuthParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV7PermissionsGroupRolesAuth>>,
  TError,
  {
    data: BodyType<RoleGroupRolePermissionPatchRequest>;
    params?: PatchV7PermissionsGroupRolesAuthParams;
  },
  TContext
> => {
  const mutationKey = ['patchV7PermissionsGroupRolesAuth'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV7PermissionsGroupRolesAuth>>,
    {
      data: BodyType<RoleGroupRolePermissionPatchRequest>;
      params?: PatchV7PermissionsGroupRolesAuthParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return patchV7PermissionsGroupRolesAuth(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV7PermissionsGroupRolesAuthMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV7PermissionsGroupRolesAuth>>
>;
export type PatchV7PermissionsGroupRolesAuthMutationBody =
  BodyType<RoleGroupRolePermissionPatchRequest>;
export type PatchV7PermissionsGroupRolesAuthMutationError = ErrorType<unknown>;

/**
 * @summary patchPermissionGroupRolesAuthList
 */
export const usePatchV7PermissionsGroupRolesAuth = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV7PermissionsGroupRolesAuth>>,
      TError,
      {
        data: BodyType<RoleGroupRolePermissionPatchRequest>;
        params?: PatchV7PermissionsGroupRolesAuthParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchV7PermissionsGroupRolesAuth>>,
  TError,
  {
    data: BodyType<RoleGroupRolePermissionPatchRequest>;
    params?: PatchV7PermissionsGroupRolesAuthParams;
  },
  TContext
> => {
  const mutationOptions = getPatchV7PermissionsGroupRolesAuthMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary getPermissionGroupRolesAuthDefaultList
 */
export const getV7PermissionsGroupRolesAuthDefault = (
  params: MaybeRef<GetV7PermissionsGroupRolesAuthDefaultParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<RoleGroupRolePermissionResponse>(
    {
      url: `/api/v7/permissions/group-roles/auth-default`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PermissionsGroupRolesAuthDefaultQueryKey = (
  params?: MaybeRef<GetV7PermissionsGroupRolesAuthDefaultParams>,
) => {
  return [
    'api',
    'v7',
    'permissions',
    'group-roles',
    'auth-default',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PermissionsGroupRolesAuthDefaultQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PermissionsGroupRolesAuthDefault>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7PermissionsGroupRolesAuthDefaultParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PermissionsGroupRolesAuthDefault>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PermissionsGroupRolesAuthDefaultQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PermissionsGroupRolesAuthDefault>>
  > = ({ signal }) => getV7PermissionsGroupRolesAuthDefault(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PermissionsGroupRolesAuthDefault>>,
    TError,
    TData
  >;
};

export type GetV7PermissionsGroupRolesAuthDefaultQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PermissionsGroupRolesAuthDefault>>
>;
export type GetV7PermissionsGroupRolesAuthDefaultQueryError = ErrorType<unknown>;

/**
 * @summary getPermissionGroupRolesAuthDefaultList
 */

export function useGetV7PermissionsGroupRolesAuthDefault<
  TData = Awaited<ReturnType<typeof getV7PermissionsGroupRolesAuthDefault>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7PermissionsGroupRolesAuthDefaultParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PermissionsGroupRolesAuthDefault>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PermissionsGroupRolesAuthDefaultQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getPermissionGroupRoleSetting
 */
export const getV7PermissionsGroupRolesAuthSetting = (
  params: MaybeRef<GetV7PermissionsGroupRolesAuthSettingParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<RoleGroupRolePermissionResponse>(
    {
      url: `/api/v7/permissions/group-roles/auth/setting`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PermissionsGroupRolesAuthSettingQueryKey = (
  params?: MaybeRef<GetV7PermissionsGroupRolesAuthSettingParams>,
) => {
  return [
    'api',
    'v7',
    'permissions',
    'group-roles',
    'auth',
    'setting',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PermissionsGroupRolesAuthSettingQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PermissionsGroupRolesAuthSetting>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7PermissionsGroupRolesAuthSettingParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PermissionsGroupRolesAuthSetting>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PermissionsGroupRolesAuthSettingQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PermissionsGroupRolesAuthSetting>>
  > = ({ signal }) => getV7PermissionsGroupRolesAuthSetting(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PermissionsGroupRolesAuthSetting>>,
    TError,
    TData
  >;
};

export type GetV7PermissionsGroupRolesAuthSettingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PermissionsGroupRolesAuthSetting>>
>;
export type GetV7PermissionsGroupRolesAuthSettingQueryError = ErrorType<unknown>;

/**
 * @summary getPermissionGroupRoleSetting
 */

export function useGetV7PermissionsGroupRolesAuthSetting<
  TData = Awaited<ReturnType<typeof getV7PermissionsGroupRolesAuthSetting>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7PermissionsGroupRolesAuthSettingParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PermissionsGroupRolesAuthSetting>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PermissionsGroupRolesAuthSettingQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
